import { useMemo } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { DeviceFilters } from '../types';

const defaults: DeviceFilters = {
  limit: 10,
  page: 0,
  orderBy: 'createdAt',
  order: 'desc',
  'createdAt.min': undefined,
  'createdAt.max': undefined,
  status: undefined,
  userId: undefined,
};

const numberFields: (keyof DeviceFilters)[] = ['limit', 'page', 'userId'];

export function useDeviceFilters(initialFilters: Partial<DeviceFilters> = {}) {
  const mergedDefaults = useMemo(
    () => ({ ...defaults, ...initialFilters }),
    [initialFilters]
  );

  return useUrlFilters<DeviceFilters>({ defaults: mergedDefaults, numberFields });
}
